<div id="alta-emisor-block-container">
  <div id="left-block">
    <p class="display-01-black" id="title">
      ¡Bienvenido al módulo de <br />
      facturación electrónica!
    </p>
    <p class="subheading-01-semi-bold">
      Para poder habilitarlo y acceder a todas sus funciones, es necesario
      <br />
      que te des de alta como Emisor.
    </p>
    <br />
    <p class="subheading-01-semi-bold">
      Completá el formulario (una vez por oficina) y esperá a ser contactado.
    </p>
    <qr-button
      [config]="buttonWithIcon40pxHierarchy1"
      (click)="onForm()"
    ></qr-button>
  </div>
  <div id="right-block">
    <div id="img-container">
      <div id="img"></div>
    </div>
  </div>
</div>
